// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"vC-z","hovered":"wC-z","hoverImage":"xC-z","mainImage":"yC-z","imageNoBackground":"zC-z","fullSizeImage":"AC-z"};